import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
/**
 * Handles the property remappings history feature (V2 backend).
 *
 * @since 3.0.0
 */
var PropertyRemappingsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyRemappingsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get the mappable plants used to populate the remapping "plant" dropdown.
     * Labels are localized server-side based on the request language. The
     * returned keys are exactly those accepted by the create endpoint.
     *
     * @since 3.0.0
     */
    PropertyRemappingsService.prototype.getPlants = function () {
        return this.apiService.apiCall("GET", "property-remappings/plants", {}, undefined, undefined, undefined, "v2");
    };
    /**
     * Get the paginated remapping history for a property.
     *
     * @since 3.0.0
     *
     * @param propertyId Property identifier
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name (date | createdAt | plant)
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with filtering data
     */
    PropertyRemappingsService.prototype.getList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "property-remappings/" + propertyId, params, undefined, undefined, undefined, "v2");
    };
    /**
     * Create a new remapping record for a property. Date and mapping user are
     * derived server-side from the property mapping status; only plant and
     * description are sent.
     *
     * @since 3.0.0
     *
     * @param propertyId Property identifier
     * @param remapping Object with the plant key and the description
     */
    PropertyRemappingsService.prototype.create = function (propertyId, remapping) {
        return this.apiService.apiCall("POST", "property-remappings/" + propertyId, remapping, undefined, undefined, undefined, "v2");
    };
    /**
     * Update an existing remapping record. Partial update: only the provided
     * fields are changed. The FE only edits plant and description; date and
     * mapping user are kept as the server-derived snapshot.
     *
     * @since 3.0.0
     *
     * @param propertyId Property identifier
     * @param remappingId Remapping record identifier
     * @param remapping Object with the fields to update
     */
    PropertyRemappingsService.prototype.update = function (propertyId, remappingId, remapping) {
        return this.apiService.apiCall("PATCH", "property-remappings/" + propertyId + "/" + remappingId, remapping, undefined, undefined, undefined, "v2");
    };
    /**
     * Delete a remapping record.
     *
     * @since 3.0.0
     *
     * @param propertyId Property identifier
     * @param remappingId Remapping record identifier
     */
    PropertyRemappingsService.prototype.delete = function (propertyId, remappingId) {
        return this.apiService.apiCall("DELETE", "property-remappings/" + propertyId + "/" + remappingId, {}, undefined, undefined, undefined, "v2");
    };
    /**
     * Get an xlsx export of the whole remapping history of a property.
     *
     * @since 3.0.0
     *
     * @param propertyId Property identifier
     */
    PropertyRemappingsService.prototype.getExport = function (propertyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "property-remappings/export/" + propertyId, {}, { responseType: "blob" }, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    PropertyRemappingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PropertyRemappingsService_Factory() { return new PropertyRemappingsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: PropertyRemappingsService, providedIn: "root" });
    return PropertyRemappingsService;
}());
export { PropertyRemappingsService };
